import type { PinKindFields } from './pinMediaKind';

export type PinRendererProps = { pin: PinKindFields; autoPlay: boolean };

/** The fields of a pin's file the renderers read. */
export type PinFileFields = {
  id?: number;
  name?: string;
  type?: string;
  mime_type?: string;
  url?: string;
};

export function fileOf(pin: PinKindFields): PinFileFields | undefined {
  return pin.file && typeof pin.file === 'object'
    ? (pin.file as PinFileFields)
    : undefined;
}
